<div class="pdf-page app-aul-023-24" id="aul02324">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center"><b> WIRING EXCLUSION </b></p>

  <p class="font-medium">
    <b> THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>
  <br />
  <p class="font-small">
    This endorsement modifies insurance provided under the following forms.
    <br />
    CAUSES OF LOSS - SPECIAL FORM
  </p>
  <br />
  <p class="font-small">
    The following <b>Wiring Exclusion</b> is added to this policy:
  </p>
  <div class="font-small">
    We will not pay for loss or damage caused by or resulting directly or
    indirectly from the existence and/or use of:
    <ol class="ps-20">
      <li>Pigtail wiring</li>
      <li>Aluminum wiring</li>
      <li>Federal Pacific Electrical Panels.</li>
      <li>Stab Lok Electrical Panels.</li>
      <li>Zinsco (GTE-Sylvania) Electrical Panels.</li>
      <li>Challenger (Eaton/Cutler Hammer) Electrical Panels.</li>
    </ol>
  </div>
  <br />
  <br />
  <br />
  <p class="font-small">
    <b>All other terms and conditions of this policy remain unchanged.</b>
  </p>
</div>
